import(/* webpackMode: "eager" */ "/codebuild/output/src2527237926/src/fortune-agro/src/app/page.tsx");
